import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orderInfo: null,
  orderStatus: null,
  pastOrderDetails: null,
  orderType: "asap", // Default to ASAP
  schedule: null, // Will store schedule object if scheduled
  comments: "", // Add comments to store order notes
};

const orderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setPastOrderDetails: (state, action) => {
      state.pastOrderDetails = action.payload;
    },
    setOrderInfo: (state, action) => {
      state.orderInfo = action.payload;
    },
    setOrderStatus: (state, action) => {
      state.orderStatus = action.payload;
    },
    setOrderType: (state, action) => {
      state.orderType = action.payload;
    },
    setOrderSchedule: (state, action) => {
      state.schedule = action.payload;
    },
    setOrderComments: (state, action) => {
      state.comments = action.payload;
    },
    clearOrderInfo: (state) => {
      state.orderInfo = null;
      state.orderStatus = null;
      state.pastOrderDetails = null;
      state.schedule = null; // Clear schedule when order completes
      state.comments = ""; // Clear comments when order completes
    },
  },
});

export const { 
  setOrderInfo, 
  setOrderStatus, 
  setPastOrderDetails,
  setOrderType,
  setOrderSchedule,
  setOrderComments,
  clearOrderInfo,
} = orderSlice.actions;

export default orderSlice.reducer;
